import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import FinePrint from 'components/Common/FinePrint'
import Modal from 'LuxKit/Modal/Modal'

interface Props {
  offer: App.Offer
  defaultShowModal?: boolean
}

export default function FinePrintModal({ offer }: Props) {
  const intl = useIntl()
  // don't auto-open modal - user must click 'see fine print' button to see fine print
  const [showModal, setShowModal] = useState(false)

  return (
    <Modal
      size="L"
      isOpen={showModal}
      title={intl.formatMessage({
        id: 'QIO5MAdhvdmK01SE8hMl',
        defaultMessage: 'Fine print',
        description: 'Title for the fine print modal in support assistant chat',
      })}
      onClose={() => setShowModal(false)}
    >
      <FinePrint finePrint={offer.finePrint} offer={offer} />
    </Modal>
  )
}
